import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './routes/LoginPage';
import MagicLinkVerifyPage from './features/verify/MagicLinkVerifyPage';
import ProfilePage from './features/profile/ProfilePage';
import OpportunitiesPage from './features/opportunities/OpportunitiesPage';
import OpportunityDetailPage from './features/opportunities/OpportunityDetailPage';
import TalentDetailPage from './features/opportunities/TalentDetailPage';
import { NotFoundPage } from './routes/NotFoundPage';
import { ProtectedRoute } from './routes/ProtectedRoute';
import { PortalLayout } from './components/PortalLayout';

/**
 * Router root del Client Portal.
 *
 * SW-309 dejó placeholders. SW-310 implementó LoginPage. SW-311 agregó
 * AuthProvider + ProtectedRoute. SW-330/SW-403 lista de opportunities,
 * SW-331/SW-405 detalle del shortlist + talents, SW-332/SW-502 acciones +
 * comentarios — todo PORTADO del repo legacy scouting-wizard-client-portal
 * que tenía la implementación completa con tests.
 *
 * SW-128 opt C: las routes protegidas ahora están anidadas bajo PortalLayout —
 * sidebar persistente con nav + tenant brand + locale switcher + logout. Esto
 * reemplaza el AppBar duplicado que cada page renderizaba antes (mis SW-330/331
 * inicial; las versiones del legacy YA asumían PortalLayout — el port mantuvo
 * esa convención correcta).
 *
 * Las routes anidadas comparten el shell:
 *   /opportunities                                      → lista
 *   /opportunities/:shortlistId                         → detalle del shortlist
 *   /opportunities/:shortlistId/talents/:talentId       → detalle del talent
 *   /profile                                            → settings del user
 */
export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/opportunities" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/magic-link/verify" element={<MagicLinkVerifyPage />} />

      {/* Routes protegidas anidadas bajo PortalLayout. ProtectedRoute envuelve
          la layout para que el auth check corra ANTES del shell. PortalLayout
          renderiza <Outlet /> donde se monta el child route element. */}
      <Route
        element={
          <ProtectedRoute>
            <PortalLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/opportunities" element={<OpportunitiesPage />} />
        <Route path="/opportunities/:shortlistId" element={<OpportunityDetailPage />} />
        <Route
          path="/opportunities/:shortlistId/talents/:talentId"
          element={<TalentDetailPage />}
        />
        <Route path="/profile" element={<ProfilePage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
